export const JOB_POSITIONS_INDEX__SET_ALL = 'JOB_POSITIONS_INDEX__SET_ALL';
export const JOB_POSITIONS_INDEX__ADD_RESOURCE = 'JOB_POSITIONS_INDEX__ADD_RESOURCE';
export const JOB_POSITIONS_INDEX__UPDATE_RESOURCE = 'JOB_POSITIONS_INDEX__UPDATE_RESOURCE';
export const JOB_POSITIONS_INDEX__REMOVE_RESOURCE = 'JOB_POSITIONS_INDEX__REMOVE_RESOURCE';
export const JOB_POSITIONS_INDEX__CLEAR_ALL = 'JOB_POSITIONS_INDEX__CLEAR_ALL';
